import { render, staticRenderFns } from "./IconBackward.vue?vue&type=template&id=575137d7"
import script from "./IconBackward.vue?vue&type=script&lang=js"
export * from "./IconBackward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports